// libs
import { useRouter } from 'hooks/useRouter'
// types
import { IRisk } from 'types/graphql'

/**
 * The record that owns the related forms set — the parent of the record at hand.
 *
 * It comes from the record itself, never from the URL: `parentRiskId` used to be passed around on
 * every transition and was dropped on some of them, which made the set resolve against the wrong
 * record. The one exception is the multiple route (`/forms/edit/template/:templateId`), which has
 * no record at all and no other source for the owner — recognised here by the absence of a record
 * id in the URL. On a record route a stale `parentRiskId` from an old link is ignored.
 */
export const useParentRiskId = (risk?: IRisk): string => {
  const router = useRouter()

  if (risk?.parentRiskId) {
    return risk.parentRiskId
  }

  return router.query.id ? undefined : (router.query.parentRiskId as string)
}
